import { useState } from "react";
import SectionHeading from "./SectionHeading";
import PosterCard from "./PosterCard";
import { catalogAnime, genreTabs } from "@/mocks/anime";

const tabKeywords: Record<string, string[]> = {
  恋爱: ["恋爱", "文艺", "青春", "情感"],
  热血: ["热血", "运动", "竞技", "偶像", "音乐"],
  奇幻: ["奇幻", "冒险", "武侠", "仙侠"],
  科幻: ["科幻", "悬疑"],
  日常治愈: ["日常", "治愈", "美食", "校园"],
  悬疑: ["悬疑", "推理"],
  国漫: [],
};

export default function Catalog() {
  const [activeTab, setActiveTab] = useState("全部");

  const filtered =
    activeTab === "全部"
      ? catalogAnime
      : catalogAnime.filter((item) => {
          if (activeTab === "国漫") return item.region === "国漫";
          const keywords = tabKeywords[activeTab] || [];
          return keywords.some((keyword) => item.genre.includes(keyword));
        });

  return (
    <section id="catalog" className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-100">
      <SectionHeading
        eyebrow="类型细分"
        icon="ri-layout-grid-line"
        title="分类浏览 · 按类型快速找到想看的"
        description="类型细分是选番最直接的方式。点击下方标签即可在本页内筛选，条目会即时更新，不会跳转到其他页面。所有条目都保留了作品的题材与篇幅信息。"
      />

      <div className="mb-6 flex flex-wrap gap-2">
        {genreTabs.map((tab) => (
          <button
            key={tab}
            type="button"
            onClick={() => setActiveTab(tab)}
            aria-pressed={activeTab === tab}
            className={`px-4 py-2 rounded-full text-sm whitespace-nowrap transition-colors cursor-pointer ${
              activeTab === tab
                ? "bg-primary-500 text-background-50"
                : "bg-background-50 text-foreground-700 border border-background-300 hover:border-primary-300 hover:text-primary-700"
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="flex items-center justify-between mb-4">
        <p className="text-sm text-foreground-600">
          当前标签 <span className="font-medium text-primary-700">{activeTab}</span> · 共{" "}
          <span className="font-medium text-foreground-900">{filtered.length}</span> 部
        </p>
        <span className="text-xs text-foreground-400 hidden sm:inline">
          筛选只作用于本页内容，不会跳转
        </span>
      </div>

      {filtered.length > 0 ? (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {filtered.map((item) => (
            <PosterCard
              key={item.id}
              title={item.title}
              cover={item.cover}
              rating={item.rating}
              genre={item.genre}
              region={item.region}
              type={item.type}
              episodes={item.episodes}
              badge={item.tags[0]}
              compact
            />
          ))}
        </div>
      ) : (
        <div className="rounded-lg bg-background-50 border border-background-200/70 py-16 text-center">
          <i className="ri-inbox-line text-4xl text-foreground-300" aria-hidden="true"></i>
          <p className="mt-3 text-sm text-foreground-600">这个标签下暂时没有条目，换个类型试试。</p>
        </div>
      )}

      <p className="mt-6 text-xs text-foreground-400">
        说明：以上条目为本站整理的类型示例，用于展示筛选与浏览体验。
      </p>
    </section>
  );
}